<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="membership-hero-section cf">
        <div class="container">
            <!-- <div class="membership-hero-detail cf">
                <div *ngIf="membershipList?.general">
                    <div class="titel-box" *ngIf="membershipList?.general?.title3">
                        <h2 class="titel-name">{{membershipList?.general?.title3}}</h2>
                    </div>
                    <div class="membership-top-content" *ngIf="membershipList?.general?.subtitle3" [innerHTML]="membershipList?.general?.subtitle3">
                        <a href="{{membershipList?.general?.redirect_url3}}" target="_blank" *ngIf="membershipList?.general?.redirect_url3">REGISTER YOUR INTEREST </a>
                    </div>
                    <div class="membership-top-detail">
                        <div class="membership-top-box" *ngFor="let membership of membershipList?.data">
                            <a [routerLink]="['/membership-single', membership?.slug]">
                                <p>{{membership?.title}}</p>
                                <h4>{{membership?.subtitle}}</h4>
                            </a>
                        </div>
                        
                    </div>
                </div>
                <div class="membership-ticket-refund">
                    <a href="javascript:void(0)"><img src="assets/images/download-ticket.png"></a>
                </div>
            </div> -->
            <!-- <div class="membership-content cf" *ngIf="membershipList?.general">
                <div class="titel-box" *ngIf="membershipList?.general?.title2">
                    <h2 class="titel-name">{{membershipList?.general?.title2}}</h2>
                </div>
                <div class="membership-content-detail" *ngIf="membershipList?.general?.subtitle2" [innerHTML]="membershipList?.general?.subtitle2">
                   
                </div>
                <div class="membership-content-btn">
                    <a href="{{membershipList?.general?.redirect_url}}" target="_blank" *ngIf="membershipList?.general?.redirect_url">REGISTER YOUR INTEREST</a>
                </div>
            </div> -->
            <div class="back-to-membership-box">
                <a routerLink="/membership" title="Back to Memberships">Back to Memberships</a>
            </div>
            <div class="membership-faq-section cf">
                <div class="titel-box">
                    <h2 class="titel-name">Membership FAQs</h2>
                </div>
                <div class="membership-faq-tab-content">
                    <div class="faq-title" *ngFor="let faq of faqList?.data">
                       <a class="faq-add" >
                          <h3>{{faq?.question}}<span></span></h3>
                       </a>
                       <div class="faq-content" >
                          <p>{{faq?.answer}}</p>
                       </div>
                    </div>
                    <!-- <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>How are the programs delivered?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p >Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors. 
                          </p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>How are the programs structured?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.</p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>How long does it take to complete the programs?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors. 
                          </p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>On completion of the course will I receive a certificate?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.</p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3 >Does completion of the advanced course give guaranteed internship at Rajasthan Royals?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.
                          </p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>What are the assessments in the course? <span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.</p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>What will I gain from undertaking the programs?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors. </p>
                       </div>
                    </div>
                    <div class="faq-title">
                       <a class="faq-add" href="javascript:void(0);">
                          <h3>Who can I contact in case I have further queries?<span></span></h3>
                       </a>
                       <div class="faq-content">
                          <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.</p>
                       </div>
                    </div> -->
                 </div> 
            </div>
        </div>
    </div>
    <!-- <div class="our-partner-section cf">
        <div class="our-partner-titel">
           <div class="container">
                <div class="titel-box">
                       <h2 class="titel-name">OUR PARTNERS</h2>
                   </div>
           </div>
        </div>
        <div class="our-partner-detail cf">
            <div class="our-partner-bg"></div>
            <div class="container">
                <div class="our-partner-detail-hero">
                       <div class="our-partner-detail-hero-left">
                        <p>Official Front Of Shirt Partner</p>
                        <div class="our-partner-logo-left">
                            <img src="assets/images/img01.png">
                        </div>
                    </div>
                    <div class="our-partner-hero-right cf">
                           <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideparterConfig">
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                   </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/dMU.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img05.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                </div>
                            </div>
                        </ngx-slick-carousel>                
                    </div>
                </div>
            </div>  
        </div>
    </div> -->
</section><!-- page ends-->